import React, { useState, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';

import ArrowLink from '@elements/ArrowLink';

// -------- STYLES

const Wrapper = styled.div`
	width: 100%;
	display: block;
	height: ${({ theme, open }) =>
		open ? theme.fixedHeights.announcementBar : 0}px;
	background-color: ${({ theme }) => theme.colors.navy.main};
	position: relative;
`;

const Bar = styled.div`
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	padding: 8px 10px;
	height: 100%;

	${({ theme }) => theme.mediaQuery.breakpointMd} {
		justify-content: center;
	}
`;

const AnnouncemenContent = styled.div`
	display: flex;
	flex-direction: column;

	${({ theme }) => theme.mediaQuery.breakpointMd} {
		flex-direction: row;
		gap: 0.5rem;
	}
`;

const CloseButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	width: 23px;
	transition: 0.75s;
	cursor: pointer;

	${({ theme }) => theme.mediaQuery.breakpointMd} {
		position: absolute;
		top: 50%;
		right: 5px;
		transform: translateY(-50%);
	}
`;

const AnnouncementText = styled.p`
	color: ${({ theme }) => theme.colors.white.main};
	line-height: 100%;
	letter-spacing: 0.14px;
	font-family: ${({ theme }) => theme.fonts.body};
	font-size: 1.4rem;
	font-style: normal;
	font-weight: 400;
	line-height: 100%; /* 14px */
	letter-spacing: 0.14px;
`;

const AnnouncementArrowLinks = styled(ArrowLink)`
	a {
		font-size: 1.4rem;
		line-height: 100%; /* 14px */
		letter-spacing: 0.14px;
	}

	:hover {
		a {
			color: ${({ theme }) => theme.colors.primary.main};
		}
	}
`;

// -------- SVG

const CloseIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none">
		<mask id="a" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
			<path fill="#D9D9D9" d="M0 0h18v18H0z" />
		</mask>
		<g mask="url(#a)">
			<path
				d="M4.8 14.25 3.75 13.2 7.95 9l-4.2-4.2L4.8 3.75 9 7.95l4.2-4.2 1.05 1.05-4.2 4.2 4.2 4.2-1.05 1.05-4.2-4.2-4.2 4.2Z"
				fill="#fff"
			/>
		</g>
	</svg>
);

export default ({ content, setAnnouncementOpen, open }) => {
	const theme = useTheme();

	const { currentAnnouncement } = content;
	const {
		announcementButtonLink,
		announcementMainText,
		announcementButtonText,
	} = currentAnnouncement;

	// Render
	if (!open) return null;

	return (
		open && (
			<Wrapper open={open} id="announcement-bar">
				<Bar>
					<AnnouncemenContent>
						<AnnouncementText as="b3">{announcementMainText}</AnnouncementText>
						<AnnouncementArrowLinks
							link={announcementButtonLink}
							linkText={announcementButtonText}
							linkColor={theme.colors.white.main}
							hoverColor={theme.colors.white.main}
							arrowSize={20}
						/>
					</AnnouncemenContent>
					<CloseButton
						aria-label="Close announcement bar"
						onClick={() => {
							setAnnouncementOpen(false);
							sessionStorage.setItem('close_annoucement', 'true');
						}}
					>
						<CloseIcon />
					</CloseButton>
				</Bar>
			</Wrapper>
		)
	);
};
